(() => {
  if (window.VadLazyVideo) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observedVideos = new WeakSet();

  const hydrate = (video) => {
    if (video.dataset.lazyVideoLoaded === 'true' || reducedMotion.matches) return;

    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    video.dataset.lazyVideoLoaded = 'true';
    video.load();
    video.play().catch(() => {});
  };

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;

          if (entry.isIntersecting) {
            hydrate(video);
            if (video.dataset.lazyVideoLoaded === 'true') {
              video.play().catch(() => {});
            }
          } else if (video.dataset.lazyVideoLoaded === 'true') {
            video.pause();
          }
        });
      }, { rootMargin: '300px 0px' })
    : null;

  const observe = (video) => {
    if (observedVideos.has(video) || reducedMotion.matches) return;
    observedVideos.add(video);

    if (observer) {
      observer.observe(video);
    } else {
      hydrate(video);
    }
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-vad-lazy-video]').forEach((video) => {
      if (video.dataset.lazyVideoAfterLoad === 'true' && document.readyState !== 'complete') {
        window.addEventListener('load', () => observe(video), { once: true });
      } else {
        observe(video);
      }
    });
  };

  window.VadLazyVideo = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
